import { gql } from '@apollo/client';
export const UpdateDocumentContent = gql `
  mutation UpdateDocumentContent($documentId: ID!, $input: FileSystemDocumentContentSetInput!) {
    updateFileSystemDocumentContent(documentId: $documentId, input: $input) {
      cloudVersionNumber
      htmlBody
    }
  }
`;
